/** 
body
{
     "tokenIds": ["72", "73", "74", "75", "76", "77", "78", "79"],
     "walletAddress": "0xF6E27BaA0E5c084FA637106E4Bbb285e66Ea59EC"
}

response

{
	"message": "Publisher NFTs opt-in status checked successfully",
	"optedInTokens": [],
	"notOptedInTokens": [
		"72",
		"73",
		"74",
		"75",
		"76",
		"77",
		"78",
		"79"
	]
}
*/

const BASE_URL = process.env.REACT_APP_OPTIN_API_URL;

export async function getOptInTokenStatus(wallet, tokenIds = []) {
    const url = `${BASE_URL}/revenue-sharing/get-token-status`
    const body = {
        tokenIds,
        walletAddress: wallet
    }

    const headers = {
        "Content-Type": "application/json"
    }

    const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body)
    })

    return res.json();
}

/**
 * 
 {
	"walletAddress": "0x8AfCbf04375A3F988144dCdE92baC1675Aa1B455",
	"timestamp": "1702304516898",
	"message": "I agree to the Publisher NFT Season 2 Terms & Conditions as published on (https://mint.opencampus.xyz/TermsAndConditions.html) and to pay a 10% marketing fee to TinyTap to market the underlying courses of the Publisher NFTs below\n\nPublisher NFT Token ID: 3,4,5\nTimestamp: 1702304516898",
	"optedInTokens": ["1","2"],
	"notOptedInTokens": ["3","4","5"]
}
 */

export async function getOptInSigningMsg(wallet, tokenIds = []) {
    const url = `${BASE_URL}/revenue-sharing/opt-in-nonce`
    const body = JSON.stringify({
        tokenIds,
        walletAddress: wallet
    })

    const headers = {
        "Content-Type": "application/json"
    }

    const res = await fetch(url, {
        method: "POST",
        headers,
        body
    })

    return res.json();
}

export async function verifyOptIn(options) {
    const url = `${BASE_URL}/revenue-sharing/verify-opt-in`
    const headers = {
        "Content-Type": "application/json"
    }

    const {
        walletAddress,
        tokenIds,
        signedMessage,
        signature,
        timestamp,
        network = process.env.REACT_APP_PNFT_NETWORK
    } = options;

    const body = JSON.stringify({
        walletAddress,
        tokenIds,
        signedMessage,
        signature,
        timestamp,
        network
    })

    const res = await fetch(url, {
        method: "POST",
        headers,
        body
    })

    return res.json();
}